import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'
import {Input} from '@components/common/base/input'
import {useForceUpdate} from '@containers/hooks'
import {cn} from '@containers/html-utils'
import {useScriptsCodeStore} from './../scripts-code-store'

interface Params {
  script: Hub
}

export const CodeFileItem = observer(({script}: Params) => {
  const [codeState, codeStore] = useScriptsCodeStore()
  const enabled = codeStore.isEnabled(script)
  const forceUpdate = useForceUpdate()
  const editing = script.id === codeState.edited?.id

  return (
    <div
      key={script.id}
      className={cn('scr-code-file-item', !enabled && 'disabled')}
    >
      {!editing && (
        <>
          <i className="fa fa-file-code-o scr-file-icon" />
          <span
            className="scr-file-name"
            title={Lang.msg.openScriptHint}
            onClick={() => codeStore.openTab(script)}
          >
            {codeStore.getName(script)}
          </span>
          <span className="scr-file-hint">{codeStore.getHint(script)}</span>
        </>
      )}
      {editing && (
        <Input
          placeholder={Lang.msg.scriptNamePlaceholder}
          defaultValue={codeStore.getName(script)}
          onSubmit={codeStore.submit}
          onCancel={codeStore.cancel}
          onBlur={codeStore.submit}
          autoFocus
          size="24"
          borders={false}
        />
      )}
      {!editing && (
        <div className="scr-file-actions">
          {enabled && (
            <div
              className="scr-file-activate"
              title={Lang.msg.enabledScriptHint}
              onClick={() => {
                codeStore.toggleEnabled(script)
                forceUpdate()
              }}
            >
              <i className="fa fa-toggle-on" /> {Lang.msg.enabledScript}
            </div>
          )}
          {!enabled && (
            <div
              className="scr-file-activate"
              title={Lang.msg.disabledScriptHint}
              onClick={() => {
                codeStore.toggleEnabled(script)
                forceUpdate()
              }}
            >
              <i className="fa fa-toggle-off" /> {Lang.msg.disabledScript}
            </div>
          )}
          <i
            className="fa fa-pencil-alt"
            title={Lang.msg.renameScript}
            onClick={() => codeStore.enableEdit(script)}
          />
          <i
            className="fa fa-trash"
            onClick={() => codeStore.deleteScript(script)}
          />
        </div>
      )}
    </div>
  )
})
